import API from "../../../services/api";
import { 
  CredentialsEmailLoginConfirmParam,
  CredentialsEmailLoginConfirmRequest,
  CredentialsLoginParam, 
  CredentialsLoginRequest, 
  CredentialsLoginResponse 
} from "../types/credentials";
import { EndpointsCredentials } from "./endpoints";

export const loginCredentials = ({user, password, email}: CredentialsLoginParam) => {
  return new Promise<CredentialsLoginResponse>(async (resolve, reject) => {
    API.post<CredentialsLoginResponse, CredentialsLoginRequest>({
      endpoint: email ? EndpointsCredentials.LoginCredentialsEmail : EndpointsCredentials.LoginCredentials,
      data: { user, password }
    })
    .then(res => {
      resolve(res.promise.data);
    })
    .catch(err => {
      reject(err);
    })
  })
}

export const loginEmailConfirm = ({confirmation_token}: CredentialsEmailLoginConfirmParam) => {
  return new Promise<CredentialsLoginResponse>(async (resolve, reject) => {
    API.post<CredentialsLoginResponse, CredentialsEmailLoginConfirmRequest>({
      endpoint: EndpointsCredentials.LoginCredentialsEmail,
      data: { confirmation_token }
    })
    .then(res => {
      resolve(res.promise.data);
    })
    .catch(err => {
      reject(err);
    })
  })
}

export default {
  loginCredentials,
  loginEmailConfirm
};
